export default __webpack_public_path__ + "static/media/borsaItaliana.173eeb39.png";